import React from 'react'
import MakeHomepage from '../make-homepage'

const MakeHomepageFr = () => {
    return <MakeHomepage languageCode="fr" />
}

export default MakeHomepageFr
